import React from 'react'

export const Gel = () => {
  return (
    <div>
        <div>
  <section className="text-gray-400 bg-gray-900 body-font">
    <div className="container px-5 py-24 mx-auto">
      <div className="flex flex-col text-center w-full mb-20">
        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-white">Jinchuuriki</h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Jinchūriki (literally meaning: Power of Human Sacrifice) are humans that have tailed beasts sealed within them. They exhibit extraordinary powers due to the immense chakra reserves they possess.</p>
      </div>
      <div className="flex flex-wrap -m-2">
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://raw.githubusercontent.com/HeroX21/mflix/547d2a57e0d33025bf1228cfe751b427de0cc1df/1.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">One-Tails - Shukaku</h2>
              <p className="text-gray-600">Sand</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://raw.githubusercontent.com/HeroX21/mflix/547d2a57e0d33025bf1228cfe751b427de0cc1df/2.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Two-Tails - Matatabi</h2>
              <p className="text-gray-600">Fire</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://qph.cf2.quoracdn.net/main-qimg-ad81cb045cfa71adf2e9d1ba5a3841c2" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Three-Tails - Isobu</h2>
              <p className="text-gray-600">Water</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://qph.cf2.quoracdn.net/main-qimg-4dd832428b97b8a6bed24567b5bbbbe9" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Four-Tails - Son Goku</h2>
              <p className="text-gray-600">Sun fire</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://raw.githubusercontent.com/HeroX21/mflix/547d2a57e0d33025bf1228cfe751b427de0cc1df/5.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Five-Tails - Kokuo</h2>
              <p className="text-gray-600">Chakra</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://raw.githubusercontent.com/HeroX21/mflix/547d2a57e0d33025bf1228cfe751b427de0cc1df/6.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Six-Tails - Saiken</h2>
              <p className="text-gray-600"> Liquid or Gas</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://i.pinimg.com/originals/e8/f6/bf/e8f6bfdf89919a9c79471c3dd58df48a.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Seven-Tails - Chomei</h2>
              <p className="text-gray-600">Air</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://raw.githubusercontent.com/HeroX21/mflix/547d2a57e0d33025bf1228cfe751b427de0cc1df/8.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Eight-Tails - Gyuki</h2>
              <p className="text-gray-600">Earth or Water</p>
            </div>
          </div>
        </div>
        <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div className="h-full flex items-center border-gray-800 border p-4 rounded-lg">
            <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src="https://wallpapers.com/images/high/kurama-the-nine-tailed-fox-l99byjlwu0t79muz.jpg" />
            <div className="flex-grow">
              <h2 className="text-white title-font font-medium">Nine-Tails - Kurama</h2>
              <p className="text-gray-600">Mix Fire</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="text-gray-400 bg-gray-900 body-font">
    <div className="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
      <img className="lg:w-2/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded" alt="hero" src="https://raw.githubusercontent.com/HeroX21/mflix/30cf7094f4d77844119f13e2c7b66273721def8a/jin.jpg" />
      <div className="text-center lg:w-2/3 w-full">
        <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white"> Jinchuuriki Powers </h1>
        <p className="leading-relaxed mb-8">Jinchūriki (literally meaning: Power of Human Sacrifice) are humans that have tailed beasts sealed within them. They exhibit extraordinary powers due to the immense chakra reserves they possess.</p>
        <div className="flex justify-center">
          <button className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">About all Jinchuuriki</button>
        </div>
      </div>
    </div>
  </section>
</div>

    </div>
  )
}
